<div class="container">
  <app-navbar *ngIf="showNavBar"></app-navbar>
  <router-outlet></router-outlet>
  <app-debugbar *ngIf="showNavBar"></app-debugbar>
</div>